import { useMutation } from '@tanstack/react-query';

import { type ParkingEntity } from 'src/features/parkingManagement/api/paymentPaymentProviders/useCreateParkingEntity';
import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query.ts';
import { formatResourcePath } from 'src/utils/regex.ts';

import type { GeneralSmartParkError } from 'src/types/errors';

interface DTO {
    parkingId: string;
    id: string;
}
const RESOURCE = '/parkings/:parkingId/parking-entity/:id/';

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, id, ...data }: DTO): Promise<ParkingEntity> => {
    return axios.patch(formatResourcePath(RESOURCE, { parkingId, id }), data);
};

interface UseMutationOptions extends MutationConfig<MutationFnType, GeneralSmartParkError> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateParkingEntity };
